import React from 'react';
import ReportingGivingDonationsPage from '../components/ReportingGivingDonationsPage';

const ReportingGivingDonationsApp = (props) => (
  <ReportingGivingDonationsPage {...props} />
);

export default ReportingGivingDonationsApp;
